
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../app/hooks";
import Header from "../../../components/header/Header";
import { selectedProject } from "../../home/appSlice/appslice";
import RaffelTicketDetailsContainer from "../container/RaffelTicketDetailsContainer";

const RaffelTicketDetailsPage = () => {
  const { id } = useParams()
  const project = useAppSelector(selectedProject)
  const navigate = useNavigate()

  useEffect(() => {
    if (!project) {
      navigate('/')
    }
  }, [project])

  return (
    <>
      {project && (
        <>
          <Header title="Raffle Ticket Item" />
          <RaffelTicketDetailsContainer id={id!} />;
        </>
      )}
    </>
  )
}

export default RaffelTicketDetailsPage
